import moment from 'moment';

// Khớp CvParserService::ERROR_DISABLED bên acms_recruit_presentation
export const CV_PARSER_DISABLED = 'cv_parser_disabled';

const FORM_DATE_FORMAT = 'DD/MM/YYYY';

const toOptions = (list) => (list || []).map((item) => ({ id: item.id, name: item.name }));

// Danh sách lựa chọn của form gửi kèm để AI chọn đúng id
export const getParseCvOptions = ({ positions, levels, experiences, languages, schools }) => ({
  positions: toOptions(positions),
  levels: toOptions(levels),
  experiences: toOptions(experiences),
  languages: toOptions(languages),
  schools: toOptions(schools),
});

const isEmpty = (value) => value === undefined || value === null || value === '' || Number.isNaN(value);

/**
 * Chỉ điền ô HR chưa nhập (hoặc đã có sẵn từ Job). Riêng giới tính form luôn có mặc định
 * nên lấy theo CV nếu AI đọc được.
 */
export const getCvFillValues = (parsed, currentValues, hasLanguages = true) => {
  const candidates = {
    full_name: parsed.full_name,
    birthday: parsed.birthday ? moment(parsed.birthday, 'YYYY-MM-DD').format(FORM_DATE_FORMAT) : null,
    email: parsed.email,
    mobile: parsed.mobile,
    school: parsed.school_id,
    position_id: parsed.position_id,
    level_id: parsed.level_id,
    experience: parsed.experience_id,
  };
  const values = {};
  Object.keys(candidates).forEach((name) => {
    if (!isEmpty(candidates[name]) && isEmpty(currentValues[name])) {
      values[name] = candidates[name];
    }
  });
  if (parsed.sex) {
    values.sex = `${parsed.sex}`;
  }

  const hasLanguage = (currentValues.candidate_languages || []).some((item) => item?.language_id);
  const languages =
    hasLanguages && !hasLanguage && parsed.languages?.length
      ? parsed.languages.map((item) => ({ language_id: item.language_id, level: item.level || '' }))
      : null;

  return { values, languages };
};
